import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import Form from "../components/Layout/Form/index";

const schema = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().required().email(),
    password: yup.string().min(3).required(),
});

export default function CreateUser() {
    const [error, setError] = useState("");
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onsubmit = (data) => {
        axios
            .post("https://shoppi-test.herokuapp.com/api/post/create", data)
            .then((result) => {
                if (result.status === 201) {
                    reset();
                    alert("User Create with Success");
                }
            })
            .catch((err) => {
                if (err) {
                    setError(err.response.data.message);
                }
            });
    };

    return (
        <Form
            error={error}
            register={register}
            handleSubmit={handleSubmit}
            onsubmit={onsubmit}
            errors={errors}
            create={true}
            title={"Create a User"}
        />
    );
}
